module.exports = "<p>\r\n  informe-calificaciones works!\r\n</p>\r\n"